<template>
  <div>
    <Breadcrumbs main="Contact Center Portal" title="Report Daily" />
    <div class="container-fluid">
      <div class="card p-4">
        <dataTableVue
          ref="refDataTable"
          :isSearch="false"
          :isExport="true"
          :isFilter="true"
          v-bind:data="{
            module: 'ccp',
            columns: columns,
            rows: rows,
            exportDetail: exportDetail,
            filter_custom: 'filterReportDynamicVue',
          }"
          @load="loadItems"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { requestService } from '../../../_services';

  export default {
    data() {
      return {
        rows: [],
        columns: [
          {
            label: 'Date',
            field: 'date_only',
            hidden: false,
          },
          {
            label: 'Name',
            field: 'user_name',
            hidden: false,
          },
          {
            label: 'Type',
            field: 'mail_type',
            hidden: false,
          },
          {
            label: 'Amount',
            field: 'count',
            hidden: false,
          },
        ],
        exportDetail: {
          fileName: 'export_daily_report',
          exportUrl: '',
        },
      };
    },
    watch: {
      show(newValue, oldValue) {
        if (oldValue) {
          this.form.map((item, i) => {
            this.form[i].value = '';
          });
        }
      },
    },
    async created() {
      await this.loadItems();
    },

    methods: {
      async loadItems(event) {
        let str = '';

        if (event != undefined) {
          for (var key in event.params) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.params[key]);
          }
          this.columns.forEach((element) => {
            if (event.sortField == element.field) {
              if (
                event.sortField == 'created_at' ||
                event.sortField == 'updated_at'
              ) {
                str += '&' + 'sortField=' + event.sortField;
              } else {
                if (element.field == 'date_only') {
                  str += '&' + 'sortField=date';
                } else {
                  str += '&' + 'sortField=' + element.field;
                }
              }
            }
          });
          if (event.filter != undefined) {
            for (var key in event.filter) {
              if (str != '') {
                str += '&';
              }
              str += key + '=' + encodeURIComponent(event.filter[key]);
            }
          }
        } else {
          str += 'sortType=desc&sortField=date';
        }

        var url = '/api/mail/report/daily/filter?' + str;
        this.exportDetail.exportUrl = '/api/mail/report/daily/export?' + str;
        return requestService
          .GetFetch('ccp', url)
          .then((response) => {
            if (response.status == 200) {
              response.text().then((text) => {
                let self = this;
                self.rows = [];
                const data = text && JSON.parse(text);
                if (data.data.data != null) {
                  self.json_data = data.data.data;
                  self.rows = data.data.data;
                  self.$refs.refDataTable.setTotalRecords(data.data.total);
                  self.$refs.refDataTable.setPages(data.data.current_page);
                } else {
                  self.$refs.refDataTable.setTotalRecords(0);
                  self.$refs.refDataTable.setPages(1);
                }
              });
            }
          })
          .catch((error) => {
            this.$notify({ text: error, type: 'danger' });
          });
      },
    },
  };
</script>

<style></style>
